import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
export function App() {
  useEffect(() => {
    document.title = 'Método ProMind Energy™';
    // Preload hero image for faster LCP
    const preloadImg = document.createElement('link');
    preloadImg.rel = 'preload';
    preloadImg.as = 'image';
    preloadImg.type = 'image/webp';
    preloadImg.setAttribute('fetchpriority', 'high');
    preloadImg.href = 'https://cdn.magicpatterns.com/uploads/w9shxTz4XCyB6HAQxF5bhK/mujer_pensativa.jpg_2.webp';
    document.head.appendChild(preloadImg);
    return () => {
      document.head.removeChild(preloadImg);
    };
  }, []);
  return <LandingPage data-id="element-0" />;
}